<template>
  <MFooter v-if="mobile" />
  <footer v-else class="footer">
    <div class="footer-top">
      <div class="container">
        <div class="footer-links">
          <div class="link-column">
            <h4>产品信息</h4>
            <ul>
              <li><a href="/product/gr/detail">汽车太阳膜</a></li>
              <li><a href="/product/bh/detail">漆面保护膜</a></li>
              <li><a href="/product/gs/detail">车身改色膜</a></li>
              <li><a href="/product/fh/detail">蓝卫仕防火膜</a></li>
            </ul>
          </div>
          <div class="link-column">
            <h4>走进首纳</h4>
            <ul>
              <li><a href="/sn/0">首纳简介</a></li>
              <li><a href="/sn/1">荣誉介绍</a></li>
              <li><a href="/sn/2">新闻资讯</a></li>
              <li><a href="/sn/3">联系我们</a></li>
            </ul>
          </div>
          <div class="link-column">
            <h4>客户服务</h4>
            <ul>
              <li><a href="#">质保系统</a></li>
              <li><a href="https://jinlannami.com/mendianchaxun/">服务网点</a></li>
              <li><a href="/service/quote">报价查询</a></li>
            </ul>
          </div>
        </div>
        <div class="footer-qr">
           <p>科技铸造首纳 安全守护家人</p>
           <div class="qr-codes">
             <div class="qr-code-item">
               <img src="./assets/qr-wechat.jpg" alt="微信公众号">
               <span>微信公众号</span>
             </div>
             <div class="qr-code-item">
               <img src="./assets/qr-video.jpg" alt="视频号">
               <span>视频号</span>
             </div>
           </div>
        </div>
      </div>
    </div>
    <div class="footer-bottom">
      <div class="container">
        <p>Copyright ©2010 - 2022 苏州今蓝纳米科技有限公司 苏ICP备16033581号-1 | <img src="./assets/beian.png" alt="公安备案" style="height: 14px; vertical-align: middle;"> 苏公网安备 32050002002855号 | 主营：汽车太阳膜 汽车车衣 汽车玻璃膜 隐形隔热膜 车窗膜 漆面保护膜 汽车贴膜</p>
      </div>
    </div>
  </footer>
</template>

<script>
import Browser from '@/utils/browser'
import MFooter from './m-footer'

export default {
  components: { MFooter },

  data() {
    return {
      mobile: Browser.mobile
    }
  }
}
// Footer component logic can go here if needed
</script>

<style scoped>
.footer {
  color: #ccc; /* Light gray text */
}

.footer-top {
  background-color: #2c3e50; /* Dark blue-gray background */
  padding: 40px 0;
}

.footer-bottom {
  background-color: #1a2531; /* Slightly darker background */
  padding: 15px 0;
  font-size: 12px;/* px-to-viewport-ignore */
  text-align: center;
}

.container {
  max-width: 1234px;
  margin: 0 auto;
  padding: 0 10px;
  display: flex; /* Use flexbox for layout */
  justify-content: space-between;
  align-items: flex-start; /* Align items to the top */
}

.footer-links {
  display: flex;
  flex-grow: 1; /* Allow link columns to take available space */
}

.link-column {
  margin-right: 60px; /* Adjust spacing between columns */
}

.link-column:last-child {
  margin-right: 0;
}


.link-column h4 {
  color: #fff;
  margin-bottom: 15px;
  font-size: 16px;/* px-to-viewport-ignore */
  font-weight: normal;
}

.link-column ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.link-column li {
  margin-bottom: 10px;
}

.link-column a {
  color: #ccc;
  text-decoration: none;
  font-size: 14px;/* px-to-viewport-ignore */
}

.link-column a:hover {
  color: #fff;
}

.footer-qr {
  text-align: center;
  margin-left: 40px; /* Space between links and QR codes */
}

.footer-qr p {
    color: #fff;
    margin-bottom: 15px;
    font-size: 14px;/* px-to-viewport-ignore */
}

.qr-codes {
    display: flex;
}

.qr-code-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 0 15px; /* Spacing between QR codes */
}


.qr-code-item img {
  width: 100px; /* px-to-viewport-ignore */
  height: 100px;/* px-to-viewport-ignore */
  margin-bottom: 5px;
  background-color: white; /* Placeholder background */
  padding: 5px; /* Optional padding if needed */
  border: 1px solid #ddd;
}

.qr-code-item span {
    font-size: 12px;/* px-to-viewport-ignore */
    color: #ccc;
}

.footer-bottom .container {
    justify-content: center; /* Center the bottom content */
}

.footer-bottom p {
  margin: 0;
  color: #aaa; /* Slightly different color for bottom text */
}

.footer-bottom img {
    margin: 0 5px; /* Space around the备案 icon */
}

</style> 